import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Save } from 'lucide-react';
import { useAuthStore } from '../store/authStore';
import { api } from '../lib/api';

export function ProfilePage() {
  const { user, updateUser } = useAuthStore();
  const [name, setName] = useState(user?.name || '');
  const [success, setSuccess] = useState(false);

  const mutation = useMutation({
    mutationFn: () => api.put('/api/auth/profile', { name }),
    onSuccess: () => {
      updateUser({ name });
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    },
  });

  return (
    <div className="max-w-2xl mx-auto animate-fadeIn">
      <h1 className="text-2xl font-bold mb-6" style={{ color: 'var(--text-primary)' }}>プロフィール</h1>
      <div className="card p-6">
        <div className="flex items-center gap-6 mb-8">
          <div className="w-20 h-20 rounded-full flex items-center justify-center text-white text-2xl font-bold" style={{ backgroundColor: 'var(--accent-color)' }}>
            {user?.name?.charAt(0).toUpperCase() || 'U'}
          </div>
          <div>
            <h2 className="text-xl font-semibold" style={{ color: 'var(--text-primary)' }}>{user?.name}</h2>
            <p style={{ color: 'var(--text-secondary)' }}>{user?.email}</p>
            <span className="badge badge-info mt-2">
              {user?.role === 'admin' ? '管理者' : user?.role === 'tax_advisor' ? '税理士' : 'ユーザー'}
            </span>
          </div>
        </div>
        {success && <div className="mb-4 p-3 rounded-lg bg-green-50 dark:bg-green-900/20 text-green-600 text-sm">プロフィールを更新しました</div>}
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1" style={{ color: 'var(--text-primary)' }}>表示名</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="w-full px-3 py-2 rounded-lg border text-sm" style={{ backgroundColor: 'var(--input-bg)', borderColor: 'var(--input-border)', color: 'var(--text-primary)' }} />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1" style={{ color: 'var(--text-primary)' }}>メールアドレス</label>
            <input type="email" value={user?.email || ''} disabled className="w-full px-3 py-2 rounded-lg border text-sm opacity-50" style={{ backgroundColor: 'var(--input-bg)', borderColor: 'var(--input-border)', color: 'var(--text-primary)' }} />
            <p className="text-xs mt-1" style={{ color: 'var(--text-muted)' }}>メールアドレスは変更できません</p>
          </div>
        </div>
        <div className="mt-6">
          <button onClick={() => mutation.mutate()} disabled={mutation.isPending} className="flex items-center gap-2 px-4 py-2 rounded-lg text-white font-medium disabled:opacity-50" style={{ backgroundColor: 'var(--accent-color)' }}>
            <Save size={18} />{mutation.isPending ? '保存中...' : '変更を保存'}
          </button>
        </div>
      </div>
    </div>
  );
}

